import React from 'react';
import { AccountType, PayedBy } from '../../../shared/Constants';
import { Field, useFormikContext } from 'formik';
import { RadioButton } from 'primereact/radiobutton';
import { defineMessages, useIntl } from 'react-intl';

const messages = defineMessages({
  payedByClient: {
    id: 'accounts.add-client.payed-by-client',
    defaultMessage: "GPI invoices the client",
  },
  payedByParent: {
    id: 'accounts.add-client.payed-by-parent',
    defaultMessage: "GPI invoices me and I invoice the client",
  },
});

const PayedByInput = ({ parentAccountType }) => {
  const { formatMessage } = useIntl();
  const {
    values: { payedBy },
    setFieldValue,
  } = useFormikContext();

  if (parentAccountType === AccountType.GSC) {
    return (
      <>
        <div className="p-col-12">
          <Field
            id="payedByClient"
            name="payedBy"
            component={RadioButton}
            onChange={(e) => {
              setFieldValue('payedBy', e.value);
            }}
            checked={payedBy === PayedBy.PAYED_BY_SELF}
            value={PayedBy.PAYED_BY_SELF}
          />
          <label htmlFor="payedByClient">{formatMessage(messages.payedByClient)}</label>
        </div>
        <div className="p-col-12">
          <Field
            id="payedByGPI"
            name="payedBy"
            component={RadioButton}
            onChange={(e) => {
              setFieldValue('payedBy', e.value);
            }}
            checked={payedBy === PayedBy.PAYED_BY_PARENT}
            value={PayedBy.PAYED_BY_PARENT}
          />
          <label htmlFor="payedByGPI">{formatMessage(messages.payedByParent)}</label>
        </div>
      </>
    );
  }

  return null;
};

export default PayedByInput;
